<template>
  <div class="map-vue-wrapper">
    <div class="map-vue-wrapper__nav" v-if="!isProduct && !((isShops || isServices) && userType === $constants.USER_TYPE.CUSTOMER)">
      <input
        ref="autocomplete"
        type="text"
        v-if="isSearchVisible"
        id="addressSearch"
        class="control control--input control-box__control map-vue-wrapper__nav-search"
        name="text"
        :placeholder="$t('start_tap_to_search')"
      />
      <div class="find_me_btn" @click="FIND_ME" v-if="!isCheckout">
        <svg width="30"
             height="30"
             viewBox="0 0 30 30"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="15"
                   cy="25.8889"
                   rx="11"
                   ry="3.11111"
                   fill="#E7E7E7" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9588 25.5748C15.9588 25.5748 24.9832 18.4064 24.9832 10.6662C24.9832 5.32771 20.5136 1 15 1C9.48651 1 5.0169 5.32771 5.0168 10.6662C5.0168 18.4064 14.0412 25.5748 14.0412 25.5748C14.5685 25.9936 15.4315 25.9936 15.9588 25.5748ZM14.9997 16.1803C18.0145 16.1803 20.4585 13.8153 20.4585 10.8979C20.4585 7.98055 18.0145 5.61556 14.9997 5.61556C11.9849 5.61556 9.54088 7.98055 9.54088 10.8979C9.54088 13.8153 11.9849 16.1803 14.9997 16.1803Z"
            fill="#E7E7E7"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9315 25.5815C15.9315 25.5815 24.7714 18.5639 24.7714 10.9866C24.7714 5.76034 20.3931 1.52365 14.9924 1.52365C9.59159 1.52365 5.21339 5.76034 5.21329 10.9866C5.21329 18.5639 14.0531 25.5815 14.0531 25.5815C14.5697 25.9916 15.415 25.9916 15.9315 25.5815ZM14.9997 16.1803C18.0146 16.1803 20.4585 13.8153 20.4585 10.8979C20.4585 7.98055 18.0146 5.61556 14.9997 5.61556C11.9849 5.61556 9.54095 7.98055 9.54095 10.8979C9.54095 13.8153 11.9849 16.1803 14.9997 16.1803Z"
            fill="#909090"
          />
        </svg>
        <button class="link link--pseudo" type="button">{{ $t('my_current_place') }}</button>
      </div>
    </div>
    <slot name="toggle-filters"></slot>
    <div class="map-spots-wrapper" :class="{ 'map-spots-wrapper-—shops': isShops, 'map-spots-wrapper--services': isServices }">
      <slot name="filters"></slot>
      <div
        class="map-vue"
        :class="{
          'map-vue--without-list': withoutList && !isServices,
          'map-vue--checkout': isCheckout || isProduct,
          'map-vue--services': isServices,
          'map-vue--not-checkout': !isCheckout && !isProduct,
          'map-vue--hidden-mob': !isMapActive && (isCheckout || isProduct || isServices)
        }"
      ></div>
      <DeliverySpotsList
        :class="{ 'map-vue--hidden-mob': isMapActive, 'delivery-spots--hidden': isServices }"
        v-if="!withoutList"
        :mail-name="mailName"
        :spots-info="spotsList"
        @selectSpot="selectSpot"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DeliverySpotsList from '../checkout/delivery/DeliverySpotsList'
import { MarkerClusterer } from '@googlemaps/markerclusterer'

export default {
  name: 'VueMap',
  components: { DeliverySpotsList },
  props: {
    spotsList: {
      type: Array
    },
    mailName: {
      type: String,
      default: 'pickup'
    },
    ourSpotsList: {
      type: Array
    },
    ourMailName: {
      type: String
    },
    withoutList: Boolean,
    mapHeight: {
      type: Number
    },
    enabledMarkers: {
      type: Array,
      default: () => []
    },
    disabledMarkers: {
      type: Array,
      default: () => []
    },
    filteredShopsByCity: {
      type: Array,
      default: () => []
    },
    isServices: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShops: this.$constants.IS_SHOPS,
      isCheckout: this.$constants.IS_CHECKOUT(),
      isProduct: this.$constants.IS_PRODUCT,
      isCheckoutSuccess: this.$constants.IS_CHECKOUT_SUCCESS(),
      mapInited: false,
      isMapDragged: false
    }
  },
  computed: {
    ...mapState({
      map: state => state.map.map,
      markers: state => state.map.markers,
      selectedSpot: state => state.map.selectedSpot,
      citiesZoom: state => state.map.citiesZoom,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      selectedCityOnShops: state => state.shops.selectedCity,
      formData: state => state.checkout.formData,
      isMapActive: state => state.deliveryForm.isMapTabActive,
      userType: state => state.user.userType
    }),
    isSearchVisible () {
      return (
        (window.config.params.checkout && window.config.params.checkout.show_address_search_field) || !this.isCheckout
      )
    }
  },
  methods: {
    ...mapActions([
      'SET_MAP_ACTION',
      'SET_MAP_POSITION_BY_GEO',
      'HANDLE_ADDRESS_SEARCH',
      'INIT_AUTOCOMPLETE',
      'FIND_ME',
      'OPEN_INFO_WINDOW',
      'SET_SELECTED_SPOT_ACTION',
      'CREATE_MARKERS',
      'HANDLE_SELECT_CITY_WITHOUT_SHOPS'
    ]),
    createMarkerClusters (map, spots, icon, name) {
      // eslint-disable-next-line no-new
      const clusters = () => {
        return new MarkerClusterer({ map,
          markers: spots,
          renderer: {
            render: function ({ count, position }, stats, map) {
              let color = {
                primary: '#333333',
                secondary: '#595959'
              }
              if (icon.includes('map-cluster-up')) {
                color = {
                  primary: '#FFD56F',
                  secondary: '#FABC26'
                }
              }
              if (icon.includes('map-cluster-np')) {
                color = {
                  primary: '#ED1C24',
                  secondary: '#FF787D'
                }
              }
              if (icon.includes('map-cluster-disabled')) {
                color = {
                  primary: '#909090',
                  secondary: '#cccccc'
                }
              }
              const svg =
              `<svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="37.5" cy="62" rx="15.5" ry="3" fill="url(#paint0_radial)"/>
                <ellipse opacity="0.3" cx="37.5" cy="62" rx="15.5" ry="3" fill="url(#paint1_radial)"/>
                <path d="M56.8145 31.4188C56.8145 46.9681 39.2711 61.3689 39.2711 61.3689C38.2461 62.2104 36.5685 62.2104 35.5434 61.3689C35.5434 61.3689 18 46.9681 18 31.4188C18.0002 20.694 26.6891 12 37.4073 12C48.1256 12 56.8145 20.694 56.8145 31.4188Z" fill="${color.secondary}"/>
                <path d="M56.4036 32.062C56.4036 47.2842 39.2189 61.3821 39.2189 61.3821C38.2148 62.2059 36.5715 62.2059 35.5674 61.3821C35.5674 61.3821 18.3828 47.2842 18.3828 32.062C18.383 21.5628 26.8942 13.0516 37.3932 13.0516C47.8923 13.0516 56.4036 21.5628 56.4036 32.062Z" fill="${color.primary}"/>
                <text x="50%" y="45%" style="fill:#fff" text-anchor="middle" font-size="14" dominant-baseline="middle" font-family="Roboto,arial,sans-serif" font-weight="700">${count}</text>
                <defs>
                  <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(37.5 62) rotate(90) scale(3 14.5378)">
                    <stop/>
                    <stop offset="0.296875" stop-opacity="0.26"/>
                    <stop offset="0.405147" stop-opacity="0"/>
                    <stop offset="0.694223" stop-opacity="0"/>
                    <stop offset="1" stop-opacity="0"/>
                  </radialGradient>
                  <radialGradient id="paint1_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(37.5 62) rotate(90) scale(3 14.5378)">
                    <stop/>
                    <stop offset="0.908834" stop-opacity="0"/>
                  </radialGradient>
                </defs>
              </svg>`
              const zIndex = Number(window.google.maps.Marker.MAX_ZINDEX) + count
              const parser = new DOMParser()
              const svgEl = parser.parseFromString(svg, 'image/svg+xml').documentElement
              const clusterOptions = {
                map,
                position,
                zIndex,
                content: svgEl
              }
              return new window.google.maps.marker.AdvancedMarkerElement(clusterOptions)
            }
          }
        })
      }

      if (name) window[name] = clusters()
      else clusters()
    },
    deleteMarkerClusters (names) {
      names.forEach(name => {
        if (window[name]) {
          window[name].clearMarkers()
          delete window[name]
        }
      })
    },
    createClusters () {
      if (this.ourSpotsList) {
        const mailMarkerLastIndex = this.markers.length - this.ourSpotsList.length
        const mailMarkers = this.markers.slice(0, mailMarkerLastIndex)
        const ourSpotsMarkers = this.markers.slice(mailMarkerLastIndex)
        const clusterImg =
          this.mailName === 'ukrposhta' ? '/img/svgo/map/map-cluster-up.svg' : '/img/svgo/map/map-cluster-np.svg'

        this.createMarkerClusters(this.map, ourSpotsMarkers, '/img/svgo/map/map-cluster.svg')
        this.createMarkerClusters(this.map, mailMarkers, clusterImg)
      } else if (this.enabledMarkers.length || this.disabledMarkers.length) {
        this.createMarkerClusters(this.map, this.enabledMarkers, '/img/svgo/map/map-cluster.svg', 'enabledClusters')
        this.createMarkerClusters(
          this.map,
          this.disabledMarkers,
          '/img/svgo/map/map-cluster-disabled.svg',
          'disabledClusters'
        )
      } else {
        this.createMarkerClusters(this.map, this.markers, '/img/svgo/map/map-cluster.svg', 'clusters')
        this.$store.commit('SET_MARKER_CLUSTERS', window.clusters)
      }
    },
    selectFirstOnEnter (autocomplete) {
      const _addEventListener = autocomplete.addEventListener ? autocomplete.addEventListener : autocomplete.attachEvent
      function addEventListenerWrapper (type, listener) {
        if (type === `keydown`) {
          let origListener = listener
          listener = function (event) {
            const suggestionSelected = document.querySelectorAll('.pac-item-selected').length > 0
            if (event.which === 13 && !suggestionSelected) {
              autocomplete.dispatchEvent(new KeyboardEvent('keydown', { keyCode: '40', which: 40 }))
            }
            origListener.apply(autocomplete, [event])
          }
        }
        _addEventListener.apply(autocomplete, [type, listener])
      }
      if (autocomplete.addEventListener) {
        autocomplete.addEventListener = addEventListenerWrapper
      } else if (autocomplete.attachEvent) {
        autocomplete.attachEvent = addEventListenerWrapper
      }
    },
    selectSpot (spot) {
      this.map.setCenter({ lat: +spot.latitude, lng: +spot.longitude })

      if (spot.cartStatus !== this.$constants.CART_STATUSES.NOT_AVAILABLE && !(spot.isSuccessful || spot.isWeightDisable)) {
        this.$emit('selectSpot', spot)
        this.SET_SELECTED_SPOT_ACTION(spot)
      }

      this.markers.forEach(marker => {
        if (marker.title === spot.title) {
          this.OPEN_INFO_WINDOW({ marker, spot, mailName: this.mailName })
        }
      })
    }
  },
  watch: {
    selectedUserLocation (value) {
      if (this.mapInited) {
        this.isMapDragged = false
        const latlng = new window.google.maps.LatLng(+value.latitude, +value.longitude)
        const zoom = value.name_ru && this.citiesZoom[value.name_ru.toLowerCase()] ? this.citiesZoom[value.name_ru.toLowerCase()] : 15
        this.map.setZoom(zoom)
        this.map.setCenter(latlng)
      }
    },
    selectedCityOnShops (value) {
      if (this.mapInited) {
        if (this.filteredShopsByCity?.length) {
          const latlng = new window.google.maps.LatLng(+value.latitude, +value.longitude)
          const cityName = value.short_name || value.name
          const zoom = cityName && this.citiesZoom[cityName.toLowerCase()] ? this.citiesZoom[cityName.toLowerCase()] : 15
          this.map.setZoom(zoom)
          this.map.setCenter(latlng)
        } else {
          this.HANDLE_SELECT_CITY_WITHOUT_SHOPS(value)
        }
      }
    },
    enabledMarkers () {
      this.deleteMarkerClusters(['enabledClusters', 'disabledClusters', 'clusters'])
      this.createClusters()
    },
    spotsList (value, prevValue) {
      if (value !== prevValue && (this.isShops || (this.isProduct && !this.isMapDragged) || this.isServices) && this.mapInited) {
        this.CREATE_MARKERS({
          spotsInfo: this.spotsList,
          ourSpotsInfo: this.ourSpotsList,
          mailName: this.mailName,
          ourMailName: this.ourMailName,
          modal: this.$modal
        })
        this.createClusters()
      }
    },
    userType () {
      if (this.isShops && this.mapInited) {
        this.CREATE_MARKERS({
          spotsInfo: this.spotsList,
          ourSpotsInfo: this.ourSpotsList,
          mailName: this.mailName,
          ourMailName: this.ourMailName,
          modal: this.$modal
        })
        this.createClusters()
      }
    }
  },
  async mounted () {
    await this.$nextTick()
    await this.SET_MAP_ACTION({
      spotsInfo: this.spotsList,
      ourSpotsInfo: this.ourSpotsList,
      mailName: this.mailName,
      ourMailName: this.ourMailName,
      modal: this.$modal
    })
    await this.$nextTick()

    this.mapInited = true

    if (Object.keys(this.selectedCityOnShops).length) {
      if (!this.filteredShopsByCity?.length) {
        this.HANDLE_SELECT_CITY_WITHOUT_SHOPS(this.selectedCityOnShops)
      }
    }

    const ifDeliverySpotSelected =
      this.isCheckout && this.formData.deliveryInfo && this.formData.deliveryInfo.deliverySpot
    const isThankyouPage = this.isCheckoutSuccess

    if (this.isProduct && !this.selectedSpot && (!this.isCheckout || (!ifDeliverySpotSelected && !isThankyouPage))) {
      this.SET_MAP_POSITION_BY_GEO()
    } else if (ifDeliverySpotSelected || isThankyouPage || this.isProduct) {
      let spot
      if (isThankyouPage) {
        spot = this.spotsList[0]
      } else if (this.formData && this.formData.deliveryInfo && this.formData.deliveryInfo.deliverySpot) {
        spot = this.formData.deliveryInfo.deliverySpot
      } else if (this.selectedSpot) {
        spot = this.selectedSpot
      }
      setTimeout(() => {
        this.markers.forEach(marker => {
          if (marker.title === spot.title || marker.title === spot.description_ru) {
            this.OPEN_INFO_WINDOW({ marker, spot, mailName: this.mailName })
          }
        })
      }, 1000)
    }

    if (this.$refs.autocomplete) {
      const autocomplete = new window.google.maps.places.Autocomplete(this.$refs.autocomplete)
      autocomplete.addListener(`place_changed`, () => {
        this.HANDLE_ADDRESS_SEARCH(autocomplete)
      })
      this.INIT_AUTOCOMPLETE(autocomplete)
      this.selectFirstOnEnter(this.$refs.autocomplete)
    }

    this.map.addListener('dragstart', () => {
      this.isMapDragged = true
      this.$emit('dragstart')
    })
    this.map.addListener('dragend', () => {
      this.$emit('dragend')
    })

    if (!window.location.hash) {
      this.createClusters()
    }
  }
}
</script>

<style lang="sass">
.gm-style-iw-chr button > span
  flex-shrink: 0
.find_me_btn
  width: fit-content
  height: fit-content
  margin-bottom: 15px
  display: flex
  align-items: center
  cursor: pointer

  .link
    margin-left: 10px
    background: transparent

.map-vue
  height: auto
  width: 70%

  &--services
    width: 100%

.map-vue-wrapper
  width: 100%

.map-spots-wrapper
  display: flex

  &--shops
    position: relative

  &--services
    flex-flow: column
    width: 100vw
    margin: 0 -15px

    +mmin($mid)
      flex-flow: row nowrap
      width: 100%
      margin: 0

.delivery__map
  width: 890px
  height: 730px

  +mmax(1100)
    height: 100vh
    width: 100%

    +mmax(900)
      height: calc(100vh - 90px)

    &--hidden
      display: none

    &--visible
      display: block

.map-vue--not-checkout
  min-height: 600px
  width: 100%

  +mmin(1101)
    &:not(.map-vue--without-list)
      width: 70%

.map-vue-wrapper__search
  margin-bottom: 40px

.map-vue__spots-hidden-mob
  display: none

  +mmin($tablet--hor)
    width: 30%
    display: block

.map-vue-wrapper__nav
  padding: 0 30px
  +mmin($tablet--hor)
    display: flex
  &:empty
    display: none

.map-vue-wrapper__nav-search

  margin-bottom: 15px

  +mmin(540)
    max-width: 400px
    margin-right: 30px

.map-vue--hidden-mob:not(.map-vue--without-list)
  display: none

  +mmin(1101)
    display: block

.map-vue--hidden-mob.map-vue--services
  display: none

  +mmin($mid)
    display: block

.map-vue--checkout
  width: 100%
  height: calc(100vh - 177px)
  position: absolute

  +mmin(1101)
    width: 70%
    height: auto
    position: relative

.map-vue-wrapper .map-vue--services
  width: 100%

.delivery-spots--hidden
  display: none

  +mmin(1101)
    display: block

.gm-style-pbc
  pointer-events: none
  z-index: 4 !important

.map-vue-wrapper__nav
  display: flex
  align-items: center
  flex-wrap: wrap

.new-line
  width: 100%

  +mmin($tablet--hor)
    display: none
</style>
